export default import.meta.ROLLDOWN_FILE_URL_3gWlPd0UUi0pz5xFbx$YtA